import WatchAndWinPage from '../../../components/watchAndWin/WatchAndWinPage';

const WatchAndWin = () => {
  return <WatchAndWinPage />;
};

export default WatchAndWin;
